<template>
    <v-card>
        <v-toolbar flat color="info" dark>
            <template v-slot:extension>
                <v-row column justify="space-around" >
                    <v-select label="Visualizzazione" v-model="type" :items="types" prepend-icon="calendar_view_month" dense small style="width:60pt" class="mx-2"></v-select>
                    <v-text-field label="Data" type="date" v-model="selectedDate"  style="width:20pt" class="mx-2"></v-text-field>
                    <v-checkbox v-model="fullWeek" label="Sab/Dom" class="mx-2"></v-checkbox>
                </v-row>
            </template>

            <template v-slot:default>
                <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                    <v-icon>navigate_before</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>Calendario</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                    <v-icon>navigate_next</v-icon>
                </v-btn>
            </template>

        </v-toolbar>

        <v-sheet height="600">
            <v-calendar
                @click:event="showEvent"
                v-model="selectedDate" ref="calendar" :weekdays="weekday" :type="type" :events="events"
                :event-overlap-mode="mode" :event-overlap-threshold="30" :event-color="getEventColor"
                
                ></v-calendar>
        </v-sheet>
    </v-card>
</template>
<script>
export default {
    props: {
        value: { required: true, type: Object },
        disabled: { default: false },
        loading: { default: false },
        date:{},
    },
    data() {
        return {
            type: 'month',
            types: [
                { value: 'month', text: 'Mensile' },
                { value: 'week', text: 'Settimanale' },
                { value: 'day', text: 'Giornaliero' },
                { value: '4day', text: '4 giorni' },
            ],
            mode: 'column',// ['stack', 'column'],
            selectedDate: this.data ||moment().format('YYYY-MM-DD'),
            fullWeek: true,
            selected: false,
        }
    },
    mounted() {
    },
    computed: {
        weekday() {
            return this.fullWeek ? [1, 2, 3, 4, 5, 6, 0] : [1, 2, 3, 4, 5,];
        },
        events() {
            let events = [];

            const colors = [
                'blue', 
                'indigo', 
                'deep-purple', 
                'cyan', 
                'green',
                'orange', 
                'grey darken-1',
                'blue-grey',
                'purple lighten-1',
                'amber',
            ];
            let colorsIndex=0;
            const getNextColor = () =>{
                if(colorsIndex>=colors.length) colorsIndex=0;
                return colors[colorsIndex++];
            };

            if(this.value.tasks)
            {
                for(let task of this.value.tasks)
                {
                    for(let subTask of task.sub_tasks)
                    {
                        const name = task.name + ' / ' +subTask.name;
                        const start = new Date(`${subTask.date_start}T00:00:00`);
                        const end = new Date(`${subTask.date_end}T23:59:59`);
                        const timed = false;
                        const color = getNextColor();

                        events.push({
                            name,
                            start,
                            end,
                            color,
                            timed,
                        });
                    }
                }
            }
            return events;
        }
    },
    methods: {
        getEvents(e) {
            console.warn('getEvents',{e})
        },
        getEventColor(event) {
            return event.color || 'grey';
        },
        showEvent(event){
            this.selected = event;
            this.$emit('select', event);
        }
    },
    watch:{
        date(v){
            if(v){
                this.selectedDate = v;
            }
        },
        selectedDate(v){
            this.$emit('update:date',v);
        }
    },
    components: {},
    filters: {}
}
</script>